document.addEventListener( 'DOMContentLoaded', function () {
	const grid = document.querySelector( '.faculties-grid' );
	if ( ! grid ) return;

	const cards = grid.querySelectorAll( '.faculties-card' );
	if ( ! cards.length ) return;

	const loadMoreBtn = document.querySelector( '.load-more-btn' );
	if ( ! loadMoreBtn ) return;

	const spinner = document.querySelector( '.load-more-spinner' );

	// Scroll to block when filter is applied
	const urlParams = new URLSearchParams( window.location.search );
	if ( urlParams.has( 'faculty-school' ) || urlParams.has( 'faculty-search' ) ) {
		const offset = 450;
		const top = grid.getBoundingClientRect().top + window.pageYOffset - offset;

		window.scrollTo( {
			top,
			behavior: 'smooth',
		} );
	}

	const batchSize = 12;
	let currentVisible = batchSize;

	// Reveal a card and lazy load its image
	const revealCard = ( card ) => {
		const img = card.querySelector( 'img[data-src]' );
		if ( img ) {
			img.src = img.dataset.src;
			img.removeAttribute( 'data-src' );
		}
		card.style.display = 'block';
	};

	// Initial render
	cards.forEach( ( card, index ) => {
		if ( index < batchSize ) {
			revealCard( card );
		} else {
			card.style.display = 'none';
		}
	} );

	// Load more click
	loadMoreBtn.addEventListener( 'click', function () {
		// Show spinner properly
		if ( spinner ) spinner.style.display = 'inline-block';

		// Disable button instead of hiding
		loadMoreBtn.disabled = true;
		loadMoreBtn.style.opacity = '0.6';
		loadMoreBtn.style.pointerEvents = 'none';

		setTimeout( () => {
			const nextVisible = currentVisible + batchSize;

			for ( let i = currentVisible; i < nextVisible && i < cards.length; i++ ) {
				revealCard( cards[ i ] );
			}

			currentVisible = nextVisible;

			// Hide spinner
			if ( spinner ) spinner.style.display = 'none';

			// Re-enable button
			loadMoreBtn.disabled = false;
			loadMoreBtn.style.opacity = '1';
			loadMoreBtn.style.pointerEvents = 'auto';

			// Hide button only when no more items
			if ( currentVisible >= cards.length ) {
				loadMoreBtn.style.display = 'none';
			}
		}, 1000 ); // smooth & visible delay
	} );
} );
